import React from 'react';
import { motion } from 'framer-motion';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  background?: 'midnight' | 'navy' | 'gradient';
}
export function Section({
  children,
  className = '',
  id,
  background = 'midnight'
}: SectionProps) {
  const bgStyles = {
    midnight: 'bg-[#0f172a]',
    navy: 'bg-[#1e1b4b]',
    gradient: 'bg-gradient-to-b from-[#0f172a] to-[#1e1b4b]'
  };
  return <section id={id} className={`py-20 md:py-32 px-4 md:px-6 overflow-hidden ${bgStyles[background]} ${className}`} data-id="element-199">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.8,
      ease: 'easeOut'
    }} className="max-w-4xl mx-auto" data-id="element-200">
        {children}
      </motion.div>
    </section>;
}